import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    switch(event) {
        const bibRuleTab = document.getElementById("v-pills-bib-tab");
        const csvTab = document.getElementById("v-pills-csv-tab");
        //enable upload csv button
        csvTab.classList.remove("disabled");
        csvTab.setAttribute("aria-disabled", "false");

        csvTab.click()
    }
}